import React from "react";
import { createSvgIconComponent } from "../";

export const IconTick = createSvgIconComponent({
  viewBox: "0 0 16 13",
  children: (
    <polygon points="14.07 0 16.16 2.15 5.58 12.43 0 7.19 2.05 5 5.55 8.28 14.07 0" />
  ),
});
